import { Instagram, ArrowUpRight, Mail } from "lucide-react";
import { SITE } from "@/lib/site";
import { scrollToSection, scrollToTop } from "@/lib/scroll";

const Footer = () => {
  const go = (href) => scrollToSection(href);

  return (
    <footer data-testid="footer" className="bg-primary px-6 py-16 md:px-12 md:py-20">
      <div className="mx-auto max-w-[1400px]">
        <div className="flex flex-col gap-10 border-b border-primary-foreground/15 pb-12 lg:flex-row lg:items-end lg:justify-between">
          <div>
            <p className="max-w-xl font-display text-3xl font-medium italic leading-tight text-primary-foreground md:text-5xl">
              "Only 27% of India is financially literate — let's change that, one
              conversation at a time."
            </p>
          </div>
          <div className="flex flex-col gap-3">
            <a
              href={SITE.instagram}
              target="_blank"
              rel="noreferrer"
              data-testid="footer-instagram"
              className="group flex items-center gap-3 whitespace-nowrap rounded-full border border-primary-foreground/30 px-6 py-3.5 text-primary-foreground transition-colors hover:border-secondary hover:text-secondary"
            >
              <Instagram size={20} />
              <span className="font-medium">Follow {SITE.handle}</span>
              <ArrowUpRight size={18} className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </a>
            <a
              href={`mailto:${SITE.email}`}
              data-testid="footer-email"
              className="flex items-center gap-3 whitespace-nowrap px-6 text-sm text-primary-foreground/60 transition-colors hover:text-secondary"
            >
              <Mail size={16} />
              {SITE.email}
            </a>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-6 md:flex-row md:items-center md:justify-between">
          <button
            onClick={() => scrollToTop()}
            className="font-display text-2xl font-semibold text-primary-foreground"
          >
            {SITE.coach}<span className="text-secondary">.</span>
          </button>
          <div className="flex flex-wrap gap-x-8 gap-y-3">
            {[
              ["The Gap", "#gap"],
              ["About", "#about"],
              ["Ways to Work", "#services"],
              ["Quiz", "#quiz"],
              ["Book", "#book"],
            ].map(([label, href]) => (
              <button
                key={href}
                onClick={() => go(href)}
                className="text-sm font-medium uppercase tracking-wide text-primary-foreground/60 transition-colors hover:text-secondary"
              >
                {label}
              </button>
            ))}
          </div>
          <p className="text-sm text-primary-foreground/45">
            © {new Date().getFullYear()} {SITE.company} · {SITE.coach}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
